/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetProductDetails,
    GetAllGroups,
    // UpdateCropForcasting,
    GetProductCategoties,
    GetProductTypes,
    GetFactoriesByGroupID,
    GetRouteByFactoryID,
    GetFarmerDetailsByFactoryIDRouteID,
    GetFarmerCropMappingDetailsByProductIDFarmerID,
    GetAllProductVarietyByProductID,
    GetProductsByFactoryIDProductcatogeryID,
    GetCropWiseAvailability,

    GetVCCFactoriesByGroupID
};

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductTypes() {
    const response = await CommonGet('/api/ProductType/GetAllProductTypes', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

//For only VCC type factories
async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetRouteByFactoryID(factoryID) {
    const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + parseInt(factoryID));
    return response.data;
}

async function GetFarmerDetailsByFactoryIDRouteID(factoryID) {
    const response = await CommonGet('/api/Farmer/GetFarmerDetailsByFactoryIDRouteID', 'factoryID=' + parseInt(factoryID) + '&routeID=' + parseInt(0));
    return response.data;
}

async function GetFarmerCropMappingDetailsByProductIDFarmerID(operationEntityID, farmerID, productVarietyID) {
    const response = await CommonGet('/api/CropForcasting/GetFarmerCropMappingDetailsByProductIDFarmerID', 'operationEntityID=' + parseInt(operationEntityID) + '&farmerID=' + parseInt(farmerID) + '&cropVarietyID=' + parseInt(productVarietyID));
    return response.data;
}

async function UpdateCropForcasting(values) {
    const response = await CommonPost('/api/CropForcasting/UpdateCropForcasting', null, values);
    return response;
}

async function GetAllProductVarietyByProductID(productID) {
    const response = await CommonGet('/api/Product/GetAllProductVarietyByProductID', 'productID=' + productID);
    return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryID', 'factoryID=' + factoryID + '&productcatogeryID=' + productcatogeryID);
    return response.data;
}

async function GetCropWiseAvailability(model) {
    const response = await CommonPost('/api/CropWiseAvailabilityReport/GetCropWiseAvailability', null, model);
    return response.data;
}

